import { TranslocoPipe } from '@jsverse/transloco';
import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { DialogComponent } from 'vcp-common-ui-lib';

@Component({
    selector: 'vc-zip-upload-dialog',
    templateUrl: './zip-upload-dialog.component.html',
    imports: [TranslocoPipe, DialogComponent],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ZipUploadDialogComponent {
    @Input()
    set visible(value: boolean) {
        if (this._visible != value) {
            this._visible = value;
            this.visibleChange.emit(this._visible);
        }
    }
    get visible(): boolean {
        return this._visible;
    }
    private _visible = false;

    @Output()
    visibleChange = new EventEmitter<boolean>();

    @Output()
    fileUploadOnly = new EventEmitter<boolean>();

    uploadOnly(value: boolean): void {
        this.fileUploadOnly.emit(value);
    }
}
